import React from 'react';
import { ALabel } from '../../atoms/ALabel/index';
import { ALabelSize } from '../../atoms/ALabel/ALabel.types';
import type { MRateTitleProps } from './MRateTitle.types';
import { MRateTitleSize } from './MRateTitle.types';
import * as Styled from './MRateTitle.styles';

const COMPONENT_NAME = 'm-web-ui-kit-MRateTitle';
const TEST_ID = 'web-ui-kit-MRateTitle';

export const MRateTitle: React.FC<MRateTitleProps> = ({ text, className, ...rest }) => {
  if (!text) {
    return null;
  }

  return (
    <Styled.Wrapper className={className} data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...rest}>
      <ALabel text={text} size={ALabelSize.XS} />
    </Styled.Wrapper>
  );
};

export { MRateTitleProps, MRateTitleSize, TEST_ID as M_RATE_TITLE_TEST_ID };
